export * from './ths.service';
import { ThsService } from './ths.service';
export * from './ths.serviceInterface';
export * from './timelog.service';
import { TimelogService } from './timelog.service';
export * from './timelog.serviceInterface';
export const APIS = [ThsService, TimelogService];
